<!--  -->
<template>
    <div class="LogoCrawlDeleteHint">
      <el-dialog
        class="AbnormallyWraning"
        v-if="HintMessageList.switch"
        :visible.sync="HintMessageList.switch"
        width="600px"
        center
        >
        <div class="AbnormallyContent">
          <div class="Hint">{{$t('lang.LogoCrawlHint')}}</div>
          <div class="pullDown"><span @click="MoreFormItem = !MoreFormItem">{{$t('lang.UsageDetails')}}<span><i class="el-icon-arrow-down" v-if="!MoreFormItem"></i> <i class="el-icon-arrow-up1" v-else></i> </span></span></div>
          <div v-if="MoreFormItem">
            <div class="MessageList" v-for="(item,index) in MessageList" :key="index">
              <div class="MessageListWrap" v-if="item.value.length > 0">
                  <div class="MessageTitle">
                    {{$t(`lang.${item.title}`)}}:
                  </div>
                  <div class="MessageNameList" v-for="(item1,index1) in item.value" :key="index1 + '1'">
                    <div class="MessageName">
                      {{item1.name}}
                    </div>
                    <div class="MessageTime" v-if="item.title == 'Event'">
                      {{TimeListTransition(item1.startTime) + ' - ' + TimeListTransition(item1.endTime) }}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="AbnormallyFooter">
          <el-button type="primary" @click="HintMessageList.switch = false">{{$t('lang.GotIt')}}</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  name: 'LogoCrawlDeleteHint',
  props: {
    HintMessageList: {
      type: Object,
      default: () => ({
        switch: false,
        list: {}
      })
    }
  },
  data () {
    return {
      // 开关
      MoreFormItem: false,
      // 列表
      MessageList: [
      ],
      // 被使用功能类型
      KeyList: {
        programTemplates: 'programTemplate',
        scheduleTemplates: 'scheduleTemplate',
        secondaryEvents: 'Event',
        programs: 'bookingChannel'
      }
    }
  },
  created () {
    this.DisposeList()
  },
  mounted () {

  },
  methods: {
    // 处理列表
    DisposeList () {
      this.MessageList = []
      const list = this.HintMessageList.list
      if (list) {
        Object.keys(list).forEach(key => {
          if (this.KeyList[key]) {
            this.MessageList.push({
              title: this.KeyList[key],
              value: list[key]
            })
          }
        })
      }
    },
    // 转换显示时间
    TimeListTransition (time) {
      if (typeof time != 'number') {
        return ''
      }
      return Outil.TransitionCurrentTime(new Date(time))
    }
  }
}
</script>

<style scoped lang="less">
.LogoCrawlDeleteHint{
  ::v-deep .AbnormallyWraning{
    text-align: left;
    .el-dialog__header{
      height: 56px;
      line-height: 56px;
      border-bottom: none;
      padding-left: 0px;
    }
    .el-dialog__body{
      padding-top: 0px;
      padding-left: 30px;
      padding-right: 20px;
    }
    .el-dialog__footer{
      padding: 0px 0 25px;
    }
    .AbnormallyTitle{
      i {
        font-size: 21px;
        color: #FEB435;
      }
      span {
        font-size: 16px;
        color: #DBDBDB;
        font-weight: 500;
        margin-left: 17px;
      }
    }
    .AbnormallyContent{
      max-height: 205px;
      padding-right: 10px;
      overflow-y: auto;
      font-size: 14px;
      color: #DBDBDB;
      .Hint {
        line-height: 16px;
        margin: 10px 0;
      }
      .pullDown{
        text-align: right;
        i{
          margin-left: 5px;
        }
      }
      .MessageListWrap{
        .MessageTitle{
          // line-height: 16px;
          margin: 10px 0;
          font-weight: 700;
        }
        .MessageNameList {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .MessageName{
            line-height: 14px;
            margin-bottom: 2px;
            width: 160px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .AbnormallyFooter{
      padding-right: 10px;
      text-align: right;
      .el-button {
        padding: 9px 22px;
      }
    }
  }
}

</style>
